
import angular from 'angular';

import { HorarioDetalhadoModalService } from './modais/modal-horario-detalhado/horario-detalhado.modal.service';

export const MeurhAdmissaoModule = angular.module('MeurhAdmissaoModule', ['ui.router.state', ])
    .service('HorarioDetalhadoModalService', HorarioDetalhadoModalService)
    .name;
